import * as React from 'react';
import type { SVGIconProps } from './Icon.types';

const ArrowDownDoubleIcon = React.forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = 'currentColor', filled, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        ref={forwardedRef}
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <title>{props.title}</title>
        <path
          clipRule="evenodd"
          d="M11.9998 16.0003L16.9496 11.0506L18.3638 12.4648L11.9998 18.8288L5.63583 12.4648L7.05004 11.0506L11.9998 16.0003ZM11.9998 10.0003L16.9496 5.05055L18.3638 6.46477L11.9998 12.8288L5.63583 6.46477L7.05004 5.05055L11.9998 10.0003Z"
          fill={color}
          fillRule="evenodd"
        />
      </svg>
    );
  },
);

export default ArrowDownDoubleIcon;
